<template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvar)">
            <h6 class="mb-3 text-left">
                Edite e salve os dados gerais da {{ dispEletronica ? 'dispensa' : 'licitação' }}

                <b-button class="float-right m-1" size="sm" type="submit">
                    <font-awesome-icon icon="save" />
                    Salvar
                </b-button>
            </h6>
            <b-row class="w-100">
                <b-col cols="12" md="6">
                    <b-row class="d-flex align-items-start">
                        <b-col cols="6" class="pr-0">
                            <default-form-validation-provider label="Número" v-slot="defaultState">
                                <b-form-input id="input-numero" v-model="licitacao.NrLicitacao"
                                    :state="defaultState.state" type="number">
                                </b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="2" class="d-flex justify-content-center align-items-center mt-4 pt-2">
                            <span class="h2">/</span>
                        </b-col>
                        <b-col cols="4" class="pl-0">
                            <default-form-validation-provider label="Ano" v-slot="defaultState">
                                <b-form-input id="input-ano" v-model="licitacao.NrAnoLicitacao"
                                    :state="defaultState.state" type="number"></b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider label="Critério de Julgamento" v-slot="defaultState">
                        <b-form-select id="select-criterio-julgamento" v-model="licitacao.IdCritJulgamento"
                            @change="alertarTrocaDeCriterioDeJulgamento" :options="listaCriteriosJulgamento"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider v-if="loaded" label="Modalidade" rules="" v-slot="defaultState">
                        <span v-if="dispEletronica">{{ textoModalidadeSelecionada }}</span>
                        <div v-else class="text-left mb-2">
                            <div v-if="!modalidadeAtualVigente">
                                <span>{{ licitacao.IdModalidadeNavigation?.DeModalidade }} </span>
                                <span v-if="!!licitacao.IdModalidadeNavigation" class="text-muted"><i>(esta modalidade não está vigente)</i></span>
                            </div>
                            <b-form-select id="select-modalidade" v-model="licitacao.IdModalidade"
                                :options="listaModalidades" @change="carregarReferenciasBaseLegal"
                                :state="defaultState.state">
                            </b-form-select>
                        </div>
                        
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider label="Natureza do Objeto" v-slot="defaultState">
                        <b-form-select id="select-natureza-objeto" v-model="licitacao.IdNaturezaObjeto"
                            @change="limparNaturezaObra" :options="listaNaturezasObjeto" :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <b-overlay :show="loadingReferencias">
                        <default-form-validation-provider label="Base Legal" v-slot="defaultState">
                            <div v-if="!baseLegalAtualVigente" class="text-left mb-2">
                                <span>{{ licitacao.IdReferenciaLegalNavigation?.DeReferenciaLegal }} </span>
                                <span v-if="!!licitacao.IdReferenciaLegalNavigation" class="text-muted"><i>(esta base legal não está vigente)</i></span>
                            </div>
                            <b-form-select id="select-base-legal" v-model="licitacao.IdReferenciaLegal"
                                :options="listaBasesLegais" :state="defaultState.state"
                                :disabled=!licitacao.IdModalidade>
                            </b-form-select>
                        </default-form-validation-provider>
                    </b-overlay>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider :rules="disabledNaturezaObra ? '' : 'required'"
                        label="Natureza da Obra" v-slot="defaultState">
                        <b-form-select id="select-natureza-obra" v-model="licitacao.IdNaturezaObra"
                            :disabled="disabledNaturezaObra" :options="listaNaturezasObra" :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider label="Nr do Processo Administrativo" v-slot="defaultState"
                        rules="max:30">
                        <b-form-input id="input-nr-processo-administrativo" v-model="licitacao.DeNrProcessoAdmin"
                            :state="defaultState.state" type="text"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider label="Objeto" v-slot="defaultState" rules="max:1000">
                        <b-form-textarea id="input-objeto-licitacao" :state="defaultState.state"
                            v-model="licitacao.DeObjetoLicitacao" rows="3" max-rows="6"></b-form-textarea>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider
                        :label="dispEletronica ? 'Data de Publicação do Aviso' : 'Data de Publicação do Edital'"
                        v-slot="defaultState">
                        <b-form-datepicker id="input-data-publicacao-edital" :state="defaultState.state"
                            v-model="licitacao.DtPublicacaoEdital" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" sm="6">
                    <default-form-validation-provider label="Data da Sessão Inaugural" v-slot="defaultState">
                        <b-form-datepicker id="input-data-sessao-inaugural" :state="defaultState.state"
                            v-model="licitacao.DtSessaoInaugural" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider v-if="licitacao.getTipoArquivo() === 'salvo'"
                        :label="labelInputAnexo" rules="">
                        <span v-if="licitacao && licitacao.ArquivoEdital">Nome: {{
        licitacao.ArquivoEdital.NmArquivo }}</span>
                        <div class="d-flex justify-content-center">
                            <btn-download class="mr-2" :fazerDownload="baixarAnexo"
                                :parametros="licitacao.ArquivoEdital" />
                            <b-link class="text-dark" @click="removerArquivoEdital()">
                                <font-awesome-icon icon="times" />
                                <div style="font-size: 12px">Remover</div>
                            </b-link>
                        </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider v-else :label="labelInputAnexo" v-slot="defaultState">
                        <b-form-file v-model="licitacao.ArquivoEdital" placeholder="Nenhum arquivo selecionado"
                            accept="application/pdf" :state="defaultState.state"></b-form-file>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-form>
    </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from "vee-validate"

import BtnDownload from '@/components/shared/btn-download.vue'
import { DatePickerDefaultProps, FormGroupDefaultCols } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { PortalError } from '@/types/portal-error'
import { SelectValue } from '@/types/select-value'
import { ArquivoLicitacao } from '@/types/licitacoes/arquivo-licitacao'

const CompProps = Vue.extend({
    name: 'AbaEditarDadosIniciais',
    components: { BtnDownload, DefaultFormValidationProvider, ValidationObserver },
    props: {
        lic: {
            type: Object,
            required: true
        },
        dispEletronica: {
            type: Boolean,
            required: false
        }

    }
})

@Component
export default class AbaEditarDadosIniciais extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    formGroupCols = FormGroupDefaultCols
    valorPadraoSelect: SelectValue = { value: '', text: 'SELECIONE UMA OPÇÃO', disabled: true }
    listaCriteriosJulgamento: SelectValue[] = [this.valorPadraoSelect]
    listaModalidades: SelectValue[] = [this.valorPadraoSelect]
    listaNaturezasObjeto: SelectValue[] = [this.valorPadraoSelect]
    listaNaturezasObra: SelectValue[] = [this.valorPadraoSelect]
    listaBasesLegais: SelectValue[] = [this.valorPadraoSelect]
    loadingReferencias = false
    licitacao: Licitacao = new Licitacao()
    critJulgamentoSelecionado: SelectValue | undefined = undefined;
    modalidadeSelecionada: SelectValue | undefined = undefined;
    loaded = false;

    //consistência de critério de julgamento
    idsCriteriosLote = [4, 7]
    idCriterioOriginal = 0

    get modalidadeAtualVigente() {
        return this.listaModalidades.find(x => x.text === this.licitacao.IdModalidadeNavigation?.DeModalidade)
    }

    get baseLegalAtualVigente() {
        return this.listaBasesLegais.find(x => x.text === this.licitacao.IdReferenciaLegalNavigation?.DeReferenciaLegal)
    }

    get disabledNaturezaObra() {
        if (this.licitacao.IdNaturezaObjeto != 2) {
            this.licitacao.IdNaturezaObra = undefined
            return true
        }
        return false
    }

    get labelInputAnexo(): string {
        return this.dispEletronica ? 'Arquivo Texto do Aviso' : 'Arquivo Texto do Edital'
    }

    get textoModalidadeSelecionada(): string {
        return this.modalidadeSelecionada ? this.modalidadeSelecionada.text : ''
    }

    async carregarReferenciasBaseLegal(): Promise<void> {
        try {
            this.loadingReferencias = true
            // await new Promise(r => setTimeout(r, 2000));
            const response = await ldiService.listarRefBasesLegais(this.licitacao.IdModalidade)
            if (response && Array.isArray(response.data)) {
                this.listaBasesLegais = [this.valorPadraoSelect, ...response.data.map(re => {
                    return {
                        value: re.IdReferenciaLegal, text: re.DeReferenciaLegal
                    }
                })]
            } else {
                throw new PortalError('Não foram encontradas referências de base legal')
            }
        } catch (e: any) {
            console.error('Falha ao carregar referencias base legal', e)
            this.$toast.error(e.message)
        } finally {
            this.loadingReferencias = false
        }
    }
    limparNaturezaObra(): void {
        this.licitacao.IdNaturezaObra = undefined
    }
    /** Validar e salvar dados iniciais de nova licitação */
    async salvar(): Promise<void> {
        store.blockScreen = true
        try {
            //console.log('call editar dados iniciais licitacao . salvar')
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                //salvar a licitação 
                const retorno = await ldiService.salvarDadosIniciais(this.licitacao)
                this.$emit('atualizarLicitacao', retorno)
                this.$toast.success('Licitação salva!')
                //vamos atualizar a instância local de licitação, para que o File se comporte corretamente.
                // se isto não funcionar, o ideal é o componente pai forçar um rerender deste aqui.
                this.licitacao = retorno
                this.idCriterioOriginal = this.licitacao.IdCritJulgamento
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async montarCombos(): Promise<void> {
        const response = await ldiService.getCombosLicitacao()
        this.listaCriteriosJulgamento.push(...response.criteriosJulgamento.map(cj => {
            return { value: cj.IdCriterioJulgamento, text: cj.DeCriterioJulgamento }
        }))
        this.listaModalidades.push(...response.modalidades
            .map(m => {
                return { value: m.IdModalidade, text: m.DeModalidade }
            }))
        this.listaNaturezasObjeto.push(...response.naturezasObjeto.map(no => {
            return { value: no.IdNaturezaObjeto, text: no.DeNaturezaObjeto }
        }))
        this.listaNaturezasObra.push(...response.naturezasObra.map(no => {
            return { value: no.IdNaturezaObra, text: no.DeNaturezaObra }
        }))
        if (this.licitacao.IdReferenciaLegal > 0) {
            await this.carregarReferenciasBaseLegal()
        }
    }
    async baixarAnexo(arquivo: ArquivoLicitacao) {
        const response = await ldiService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`edital-${this.licitacao.NumeroAnoLicitacao}`, response.data)
    }
    removerArquivoEdital() {
        this.licitacao.ArquivoEdital = undefined
    }
    alertarTrocaDeCriterioDeJulgamento(novoValor) {
        // console.log('alertarTrocaDeCriterioDeJulgamento', novoValor, this.licitacao)
        if (this.licitacao.IsLote && !this.idsCriteriosLote.includes(novoValor) && this.licitacao.CountLotes > 0) {
            // console.log('informar que o cara tá saindo de lote')
            this.$bvModal.msgBoxConfirm(`Há ${this.licitacao.CountLotes} lotes cadastrados nesta licitação. Caso você troque o critério de julgamento, estes lotes serão excluídos`, {
                buttonSize: 'sm',
                cancelTitle: 'Mantenha o critério de lote',
                cancelVariant: 'outline-secondary',
                centered: true,
                headerBgVariant: 'secondary',
                headerTextVariant: 'light',
                okTitle: 'Pode apagar os lotes',
                title: 'Confirmar troca de critério de julgamento',
            }).then(value => {
                //console.log('usuário respondeu', value)
                if (value) {
                    this.licitacao.IsLote = false
                    this.idCriterioOriginal = novoValor
                } else {
                    this.licitacao.IdCritJulgamento = this.idCriterioOriginal
                }
            }).catch(err => {
                console.error('Erro ao operar o dialog de alerta de troca de critério de julgamento', err)
            })
        }
        if (!this.licitacao.IsLote && this.idsCriteriosLote.includes(novoValor) && this.licitacao.CountItens > 0) {
            console.log('informar que o cara tá virando lote')
            this.$bvModal.msgBoxConfirm(`Há ${this.licitacao.CountItens} itens cadastrados nesta licitação. Caso você troque o critério de julgamento, estes itens serão excluídos`, {
                buttonSize: 'sm',
                cancelTitle: 'Mantenha o critério atual',
                cancelVariant: 'outline-secondary',
                centered: true,
                headerBgVariant: 'secondary',
                headerTextVariant: 'light',
                okTitle: 'Pode apagar os itens',
                title: 'Confirmar troca de critério de julgamento',
            }).then(value => {
                //console.log('usuário respondeu', value)
                if (value) {
                    this.licitacao.IsLote = true
                    this.idCriterioOriginal = novoValor
                } else {
                    this.licitacao.IdCritJulgamento = this.idCriterioOriginal
                }
            }).catch(err => {
                console.error('Erro ao operar o dialog de alerta de troca de critério de julgamento', err)
            })
        }
    }
    async mounted() {
        try {
            if (this.lic.IdLicitacao > 0) {
                this.licitacao = this.lic
                this.idCriterioOriginal = this.licitacao.IdCritJulgamento
            }
            store.blockScreen = true
            await this.montarCombos()
            if (this.dispEletronica) {
                this.licitacao.IdModalidade = 38
                this.listaCriteriosJulgamento = this.listaCriteriosJulgamento.filter(x => (x.value === 1 || x.value === 4))
                this.listaModalidades = this.listaModalidades.filter(x => x.value === 38)
                this.modalidadeSelecionada = this.listaModalidades.find(x => x.value === this.licitacao.IdModalidade)
                await this.carregarReferenciasBaseLegal()
            }
            else {
                this.listaModalidades = this.listaModalidades.filter(x => x.value !== 38)
            }
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarDadosIniciaisLicitacao', e)
        } finally {
            this.loaded = true;
            store.blockScreen = false
        }
    }
}
</script>

<style></style>